import { render, staticRenderFns } from "./TooltipDescription.vue?vue&type=template&id=50005b62&scoped=true"
import script from "./TooltipDescription.vue?vue&type=script&lang=js"
export * from "./TooltipDescription.vue?vue&type=script&lang=js"
import style0 from "./TooltipDescription.vue?vue&type=style&index=0&id=50005b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50005b62",
  null
  
)

export default component.exports